module.exports = __webpack_public_path__ + "img/DE06234.7841559e.png";